// Clave de idempotencia por formulario: se crea al abrir el formulario, sobrevive a recargas (sessionStorage)
// y se renueva solo cuando la operación se confirma. Así un doble clic, una recarga o un reintento por
// pérdida de conexión no duplican la operación en el servidor.

const PREFIX = 'teo.req.';

function uuid(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
  // Respaldo para navegadores sin randomUUID.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

/** Devuelve la clave vigente para `scope` (p. ej. "producto:nuevo"), creándola si no existe. */
export function requestKey(scope: string): string {
  try {
    const existing = sessionStorage.getItem(PREFIX + scope);
    if (existing) return existing;
    const fresh = uuid();
    sessionStorage.setItem(PREFIX + scope, fresh);
    return fresh;
  } catch {
    return uuid();
  }
}

/** Descarta la clave de `scope` una vez la operación se confirmó (la siguiente será nueva). */
export function releaseKey(scope: string) {
  try {
    sessionStorage.removeItem(PREFIX + scope);
  } catch {
    /* sin almacenamiento: no hay nada que liberar */
  }
}
